import React, { useEffect } from 'react';
import '../sections/Game_parselings.css';

import V4ClubPng from '../../../assets/images/parselings/V4Club.png';
import V4ClubWebp from '../../../assets/images/parselings/V4Club.webp';
import V4DiamondPng from '../../../assets/images/parselings/V4Diamond.png';
import V4DiamondWebp from '../../../assets/images/parselings/V4Diamond.webp';
import V4heartsPng from '../../../assets/images/parselings/V4hearts.png';
import V4heartsWebp from '../../../assets/images/parselings/V4hearts.webp';
import V4SpadePng from '../../../assets/images/parselings/V4Spade.png';
import V4SpadeWebp from '../../../assets/images/parselings/V4Spade.webp';

const Game = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible', 'animate');
            observer.unobserve(entry.target);
            const cards = entry.target.querySelectorAll('.card');
            cards.forEach(card => {
              card.addEventListener('animationend', () => {
                card.classList.add('fanned');
              });
              // Add hover listeners for suit highlighting.
              card.addEventListener('mouseenter', () => {
                const suit = card.getAttribute('data-suit');
                const suitElem = document.querySelector(`.suits-grid .suit[data-suit="${suit}"]`);
                if (suitElem)
                  suitElem.classList.add('highlight');
              });
              card.addEventListener('mouseleave', () => {
                const suit = card.getAttribute('data-suit');
                const suitElem = document.querySelector(`.suits-grid .suit[data-suit="${suit}"]`);
                if (suitElem)
                  suitElem.classList.remove('highlight');
              });
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -250px 0px' } 
    );

    const fanContainer = document.querySelector('.card-fan-container');
    if (fanContainer) {
      observer.observe(fanContainer);
    }

    // Cleanup function to disconnect observer
    return () => {
      if (fanContainer) {
        observer.unobserve(fanContainer);
      }
      observer.disconnect();
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <div className="game-parselings-container">
      <div className="mechanics-grid">
        {/* Combined Choice and Parse Systems */}
        <div className="mechanics-card choice-system">
          <h2>Choice System</h2>
          <div className="power-tags">
            <span className="power-tag">Individuality</span>
            <span className="power-tag">Fate</span>
            <span className="power-tag">Choice</span>
          </div>
          <div className="card-content">
            <p>Whether you are undertaking a devious deal or enacting a daring distraction, the circumstances are never the same for any two people. The Choice System is built to embody the individuality of your own character, to represent how you want to play.</p>
            
            <h3>The Suits</h3>
            <div className="card-fan-container">
              <picture className="card club" data-suit="club">
                <div className="card-hover-wrapper">
                  <source srcSet={V4ClubWebp} type="image/webp" />
                  <img src={V4ClubPng} alt="Club Card" />
                </div>
              </picture>
              <picture className="card diamond" data-suit="diamond">
                <div className="card-hover-wrapper">
                  <source srcSet={V4DiamondWebp} type="image/webp" />
                  <img src={V4DiamondPng} alt="Diamond Card" />
                </div>
              </picture>
              <picture className="card heart" data-suit="heart">
                <div className="card-hover-wrapper">
                  <source srcSet={V4heartsWebp} type="image/webp" />
                  <img src={V4heartsPng} alt="Hearts Card" />
                </div>
              </picture>
              <picture className="card spade" data-suit="spade">
                <div className="card-hover-wrapper">
                  <source srcSet={V4SpadeWebp} type="image/webp" />
                  <img src={V4SpadePng} alt="Spade Card" />
                </div>
              </picture>
            </div>
            <div className="suits-grid">
              <div className="suit" data-suit="club">
                <span className="suit-symbol">♣</span>
                <p>Body - Tackling physical obstacles</p>
              </div>
              <div className="suit" data-suit="diamond">
                <span className="suit-symbol">⯁</span>
                <p>Diamond - Pushing through adversity.</p>
              </div>
              <div className="suit" data-suit="heart">
                <span className="suit-symbol">♥</span>
                <p>Heart - Resolving social quandaries</p>
              </div>
              <div className="suit" data-suit="spade">
                <span className="suit-symbol">♠</span>
                <p>Mind - Solving issues with intellect</p>
              </div>
            </div>
            {/* Insert Parse System section beneath Choice System */}
            <div className="parse-system">
              <h2>Parse System</h2>
              <div className="power-tags">
                <span className="power-tag">Imagination</span>
                <span className="power-tag">Cooperation</span>
                <span className="power-tag">Magic</span>
              </div>
              <div className="card-content">
                <p>
                  If the Choice System is the gears directing the fate of your characters, Parses are the heart and soul of the game. The Parse System is where your imagination and will to cooperate with others truly matters.
                </p>
                
                <div className="parse-highlight">
                  <p>Parsing is the supernatural phenomena carried out by two or more Parselings with:</p>
                  <ul>
                    <li>A simple touch</li>
                    <li>Uttering a string of words</li>
                  </ul>
                </div>

                <p>
                  A Parseling’s words are determined by their perceived role in the world. These come from anywhere – from strangers, friends, and even from the Parseling themselves. All players are involved in the process of determining the potential words each character may possess.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className="emphasis-text">Whatever happens in your story, the choice is yours.</p>
    </div>
  );
};

export default Game;